// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bLoIyKBupPF4yLh1yn6Q a,.bLoIyKBupPF4yLh1yn6Q span{color:#c70700 !important}`, "",{"version":3,"sources":["webpack://./src/js/pages/cnvs/custom-styles/_custom-link.module.scss"],"names":[],"mappings":"AACI,mDACI,wBAAA","sourcesContent":[".customPathogenicLink{\n    a,span{\n        color: #c70700 !important;\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customPathogenicLink": `bLoIyKBupPF4yLh1yn6Q`
};
export default ___CSS_LOADER_EXPORT___;
